import { Controller } from "@hotwired/stimulus"

// Live WO header clock. Keeps the greasy-hands path to one big tap.
export default class extends Controller {
  static targets = ["display", "rate", "note"]
  static values = {
    startedAt: Number,
    defaultRate: String
  }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    if (!this.hasDisplayTarget || !this.startedAtValue) return

    const now = Math.floor(Date.now() / 1000)
    const elapsed = Math.max(now - this.startedAtValue, 0)
    this.displayTarget.textContent = this.format(elapsed)
  }

  confirmStop(event) {
    const rate = window.prompt("Hourly labor rate", this.defaultRateValue || "")
    if (rate === null) {
      event.preventDefault()
      return
    }

    const normalizedRate = rate.trim()
    if (!normalizedRate || Number(normalizedRate) < 0) {
      event.preventDefault()
      window.alert("Enter a valid hourly rate before clocking out.")
      return
    }

    if (this.hasRateTarget) this.rateTarget.value = normalizedRate

    const note = window.prompt("Labor note (optional)", "")
    if (note !== null && this.hasNoteTarget) this.noteTarget.value = note.trim()
  }

  format(seconds) {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    return [h, m, s].map((part) => String(part).padStart(2, "0")).join(":")
  }
}
